import React, { useEffect } from 'react'
import { Button, Select, Form } from "antd";




const { Option } = Select;
const FormItem = Form.Item;


export default function LotNumber({
    facilityProductId,
    kitNo,
    // index,
    lot,
    onChangeLot,
    disabled,
    form,
    addSkuLot,
    removeSkuLot,
    lots,
    keyProp,
    isDynamic,
    key,
    index
}) {

    useEffect(() => {
        async function setDefaultLot() {
            if (lots?.length === 1) {
                const lot = lots[0];
                onChangeLot(lot);
            }
            else if (lots?.length > 1) {
                let allEmpty = lots?.every(
                    (item) =>
                        item.lotNumber === null ||
                        item.lotNumber === undefined ||
                        item.lotNumber === ""
                );
                if (allEmpty) {
                    let maxLot = lots[0]
                    for(let i = 0; i < lots.length; i++){
                        let item = lots[i]
                        if(item.quantity > maxLot.quantity){
                            maxLot = item
                        }
                    }
                    onChangeLot(maxLot);
                } else {

                }
            }
        }

        setDefaultLot()
    }, [])

    return <div style={{ display: "flex", gap: 8 }}>
        <FormItem
            // name={`transactions[${index}].lot`}
            name={['transactions', keyProp, 'lotNumber']}
            dependencies={[['transactions', keyProp, 'quantity']]}
            style={{ marginBottom: 0 }}
            rules={[
                ({ getFieldValue }) => ({
                    validator(_, value) {

                        const quantity = getFieldValue([
                            'transactions',
                            keyProp,
                            'quantity',
                        ])

                        if (quantity <= 0) {
                            return Promise.resolve();
                        }

                        else if (lots?.length <= 1) {
                            return Promise.resolve();
                        } else if (lots?.length > 1 && !value) {
                            // const lot = lots?.data?.find(
                            //   (lot) => lot.inventoryId === value
                            // );
                            // if (
                            //   lot?.lotNumber === "" ||
                            //   lot?.lotNumber === null ||
                            //   lot?.lotNumber === undefined
                            // ) {
                            return Promise.reject("Required");
                            // } else {
                            //   return Promise.resolve();
                            // }
                        } else {
                            return Promise.resolve();
                        }
                    },
                }),
            ]}

            className={`flatFormItem outlinedSelector`}
        >
            <Select
                className="outlinedSelector"
                placeholder={"Select Lot"}
                // disabled={disabled}
                // loading={lots?.isLoading}
                // value={lot}
                // onChange={(value) => {
                //     const lot = lots?.data?.find((lot) => lot.inventoryId === value);
                //     onChangeLot(value, lot);
                // }}
                onChange={(e, obj) => {
                    onChangeLot(obj?.data);

                }}
            >
                {lots?.map?.((opt) => (
                    <Option
                        key={opt["inventoryId"]}
                        value={opt["lotNumber"]}
                        label={"lotNumber"}
                        data={opt}
                    >
                        <> {opt["lotNumber"]}</>
                    </Option>
                ))}
            </Select>
        </FormItem>
        {/* We'll update this value manually in code */}
        <FormItem hidden name={['transactions', keyProp, 'facilityProductId']} >
            <input />
        </FormItem>
        {/* We'll update this value manually in code */}
        <FormItem hidden name={['transactions', keyProp, 'inventoryId']} >
            <input />
        </FormItem>

        <div className="flex items-center justify-center">
            {isDynamic ? (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => removeSkuLot(index)}
                    disabled={disabled || lots?.length < 2}
                >
                    -
                </Button>
            ) : (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => addSkuLot(index, lots ?? [])}
                    disabled={disabled || lots?.length < 2}
                >
                    +
                </Button>
            )}
        </div>
    </div>
}
